import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const soundsWordList = [
  "bark",
  "beat",
  "boom",
  "click",
  "crack",
  "crash",
  "echo",
  "knock",
  "laugh",
  "loud",
  "noise",
  "pop",
  "quiet",
  "ring",
  "silence",
  "snap",
  "soft",
  "sound",
  "tap",
  "volume",
];

export const soundsCollection: WordCollection = createCollection(
  "sounds",
  "Sounds & Silence",
  soundsWordList,
  { icon: "volume-high", isWordlistViewable: true },
);
